// src/pages/AccountBalance/components/exportAccountBalanceCsv.js

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum = (val) => Number(val || 0).toFixed(2);
const fmtType = (val) => (val || "").replaceAll("_", " ").toUpperCase();

/**
 * @param {object} params
 * @param {Array}   params.list    - from Redux state.accountBalance.list
 * @param {object}  params.totals  - from Redux state.accountBalance.totals
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportAccountBalanceCsv = ({
  list,
  totals,
  title    = "Cash & Bank Balance Report",
  filename = "cash_bank_balance",
}) => {
  const headers = [
    "No.", "Account Name", "Acc. Type",
    "Opening Balance", "Debit Amount (IN)",
    "Credit Amount (OUT)", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name        || "",
    fmtType(row.acc_type_id),
    fmtNum(row.opening_balance),
    fmtNum(row.received_total),
    fmtNum(row.payment_total),
    fmtNum(row.balance),
  ].map(escape));

  const totalRow = [
    "Grand Total:", "", "",
    fmtNum(totals.opening),
    fmtNum(totals.debit),
    fmtNum(totals.credit),
    fmtNum(totals.balance),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};